import React from 'react';
import { quickQuotes } from '../data/content';
import { Reveal } from './Reveal';
export function QuickQuotes() {
  return <section className="bg-paper px-5 py-16 sm:py-20 lg:px-8" aria-label="Lo que dicen los profes" data-id="element-219" data-mp="pl5x86h0liet">
      <ul className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-3 lg:gap-12" data-id="element-220" data-mp="13kxgomqavr07">
        {quickQuotes.map((item, i) => <Reveal key={item.author} delay={i * 0.05} className="h-full" data-id="element-221" data-mp="ykszsvlhcu9g" data-mpi={i}>
            <li className="flex h-full flex-col border-t-2 border-grass pt-5" data-id="element-222" data-mp="axb26jfjb1yk">
              <p className="text-[17px] leading-snug text-ink" data-id="element-223" data-mp="5z9jhzm0t4nm">“{item.quote}”</p>
              <p className="mt-auto pt-4 text-sm font-bold uppercase tracking-wide text-ink-dim" data-id="element-224" data-mp="kn4czi7urd1r">
                {item.author}
              </p>
            </li>
          </Reveal>)}
      </ul>
    </section>;
}